import 'libraries/webslidemenu/webslidemenu.js';
import 'libraries/overflow.handler.js';

import Sticky from 'node_modules/sticky-js/dist/sticky.min.js';
new Sticky('.page__header', {stickyClass: 'page__header--sticky', stickyContainer: 'main'});

if ($(window).outerWidth() > 992) {
    $('.wsmenu-list').overflowHandler({
        overflowItem: {
            text: $('.wsmenu-list').data('o') || 'Other'
        }
    }); 
}